import { Hero } from '@/components/Hero';
import { Statement } from '@/components/Statement';
import { Experiences } from '@/components/Experiences';
import { AboutCompany } from '@/components/company/AboutCompany';
import { FlagshipExperience } from '@/components/company/FlagshipExperience';
import { Difference } from '@/components/company/Difference';
import { WhatWeDo } from '@/components/company/WhatWeDo';
import { Approach } from '@/components/company/Approach';
import { Beyond } from '@/components/company/Beyond';
import { Belief } from '@/components/company/Belief';
import { PartnerContact } from '@/components/company/PartnerContact';

export const Home = ({ onDiscover, onEnquire }) => {
  return (
    <main id="top">
      <Hero />
      <Experiences onDiscover={onDiscover} />
      <Statement />
      <AboutCompany />
      <FlagshipExperience onEnquire={onEnquire} />
      <Difference />
      <WhatWeDo onDiscover={onDiscover} />
      <Approach />
      <Beyond />
      <Belief />
      <PartnerContact onEnquire={onEnquire} />
    </main>
  );
};
